import { render, staticRenderFns } from "./CustomizeMetalAC.vue?vue&type=template&id=857532d4&scoped=true"
import script from "./CustomizeMetalAC.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAC.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAC.vue?vue&type=style&index=0&id=857532d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857532d4",
  null
  
)

export default component.exports